module.exports = __webpack_public_path__ + "img/38.3f239f5a.jpg";